//core
import React from "react";
import arePropsEqual from "react-fast-compare";
import {Box, Card, Link} from "@mui/material";

//components
import CardMenu from "./components/CardMenu";

//types
import {itemListData} from "../../../../../../common/TableData";

//styles
import {useStyles} from "./styles";

//components
import DetailsInfoBlock
  from "../../../../../../common/TableData/components/TableRowItem/components/DetailsInfoBlock";

interface IMobileCardProps {
  data: itemListData;
  affiliateId: number;
  flatFeeId: number;
  paymentData: any;
}

const MobileCard: React.FC<IMobileCardProps> = ({
  data,
  affiliateId,
  flatFeeId,
  paymentData,
}): JSX.Element => {
  const styles = useStyles();

  return (
    <>
      {data.list.map((row:any, index:any) => {
        return (
          <Card key={index} className={styles.row} variant="outlined">
            {data.columns.map((column:any) => (
              <Box key={`payment-row-${column.name}`}>
                <DetailsInfoBlock
                  column={column}
                  row={row}
                  translationColumnsPrefix={'columns_for_display.table.generate_report.'}
                  inline={true}
                />
              </Box>
            ))}
            <CardMenu id={row.id} data={row} affiliateId={affiliateId} flatFeeId={flatFeeId} paymentData={paymentData}/>
          </Card>
        )
      })}
    </>
  );
};

export default React.memo(MobileCard, arePropsEqual);
